import { NavigationGuard } from 'vue-router';
import store from '@/store';

export const homeResolver: NavigationGuard = async (_to, from, next) => {
  if (from.matched.length) {
    await store.dispatch('resetState');
  }

  await store.dispatch('configuration/setTypes');
  await store.dispatch('home/setPresets');
  await store.dispatch('home/preloadPresetImages');

  // hack for a race condition with the global loader; without this, the load would show indefinitely
  await store.dispatch('app/setLoadingState', true);
  await store.dispatch('app/setLoadingState', false);

  next();
};
